"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FunctionalCheckCircle2 = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const FunctionalCheckCircle2 = _ref => {
  let {
    color = "currentColor",
    fill = "none",
    strokeWidth = "2",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: fill,
    viewBox: "0 0 24 24",
    stroke: color,
    strokeWidth: strokeWidth
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m16 9-5.5 5.5L8 12m14 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }));
};
exports.FunctionalCheckCircle2 = FunctionalCheckCircle2;
FunctionalCheckCircle2.displayName = "FunctionalCheckCircle2";